<template>
    <div class="participationRate" :id="Id"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['InjectData', 'Id'],
    data() {
        return {
            chartInstance: null
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        InjectData: {
            handler() {
                // this.participation_graphics()
                this.Proportion();
            },
            deep: true,
        }
    },

    // 方法集合
    methods: {
        Proportion(data) {
            // console.log('InjectData', this.InjectData);
            // return;
            if (!this.InjectData) {
                return;
            }
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }


            this.chartInstance = this.$echarts.init(
                document.getElementById(this.Id)
            );
            // 动态处理数据
            const seriesData = [];
            const legendData = [];
            const xAxisData = this.InjectData.map(item => item.name || item.examName || '');
            // console.log('xAxisData', xAxisData);

            const scoreFields = [
                { field: 'center_pos', name: '居中占位' },
                { field: 'grid_size', name: '占格大小' },
                { field: 'glyph_grav', name: '字形重心' },
                { field: 'combo_rel', name: '组合关系' },
                { field: 'rewind_rel', name: '收放关系' },
                { field: 'multi_dist', name: '多画等距' },
                { field: 'stroke_rel', name: '笔画关系' },
                { field: 'integrity', name: '作品完整度' }
            ];
            scoreFields.forEach(fieldObj => {
                const fieldExists = this.InjectData.some(item =>
                    item.hasOwnProperty(fieldObj.field) && item[fieldObj.field] !== null
                );

                if (fieldExists) {
                    legendData.push(fieldObj.name);
                    seriesData.push({
                        name: fieldObj.name,
                        type: 'line',
                        // stack: 'Total',
                        data: this.InjectData.map(item => {
                            const value = item[fieldObj.field];
                            // 如果是百分比形式的数值，转换为数值
                            if (typeof value === 'string' && value.endsWith('%')) {
                                return parseFloat(value);
                            }
                            return value !== undefined ? value : 0;
                        })
                    });
                }
            });
            this.chartInstance.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: legendData,
                    icon: 'rect',
                    show: true,
                    bottom: '0%',
                },
                grid: {
                    left: '8%',
                    right: '8%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xAxisData
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                            fontSize: this.graphicRatio(14),
                            formatter: '{value}'
                        }
                },
                series: seriesData
            })
            window.addEventListener("resize", () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            });
        },
    },
    mounted() {
        // this.Proportion();
        if (this.InjectData) {
            this.Proportion();
        }
    },
    updated() {
        // 确保在DOM更新后重新绘制图表
        this.$nextTick(() => {
            if (this.InjectData) {
                this.Proportion();
            }
        });
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }

        // 移除resize事件监听器
        window.removeEventListener("resize", () => {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        });
    }
}
</script>
<style scoped lang="less">
.participationRate {
    width: 100%;
    height: 100%;
}
</style>